import { defineComponent as _defineComponent } from 'vue'
import { User, AppMode } from "@/CodegenTypes";
import { mutations, queries } from "@/apollo";
import { clone, startCase } from "lodash";
import { errorMutationNotification } from "@/utils";
import { ref, watch } from "vue";
import InputGroup from "@/components/common/InputGroup.vue";
import { useQuery } from "@vue/apollo-composable";
import { addSuccessToast, addWarnToast } from "@/vue-service";
import { apolloClient } from "@/apollo";
import { useTranslation } from "@/store/translation";


export default /*#__PURE__*/_defineComponent({
  __name: 'UpdateDownlineFormModal',
  props: {
    user: null,
    value: { type: Boolean }
  },
  emits: ['input', 'submit'],
  setup(__props: any, { emit }) {

const props = __props as {
  user: User;
  value: boolean;
};




const form = ref(getDefaultForm());

const { $t } = useTranslation();


const { result } = useQuery<{ isProfileChangeWindowOpen: boolean }>(
  queries.isProfileChangeWindowOpen,
  {
    userId: props.user.userId,
    appMode: AppMode.Dd
  }
)

function toggleModal(val: boolean) {
  emit("input", val);
}

function getDefaultForm() {
  return clone({
    userId: props.user.userId,
    username: props.user.username,
    // password: "",
    status: props.user.status,
    creditGiven: props.user.creditGiven,
    autoResetBalance: props.user.autoResetBalance,
    createAgent: props.user.createAgent,
    deleteBet: props.user.deleteBet,
    createPayment: props.user.createPayment,
    statement: props.user.readStatement,
    placeBets: props.user.placeBets,
    remarks: props.user.remarks
  });
}
function handleStatusChange(val: any) {
  const value = val;
  if (props.user.status !== value) {

    addWarnToast("All downlines will also change to " + startCase(value === 'live' ? 'active' : value));
  }
  form.value.status = value
}

watch(
  () => props.user,
  () => resetForm()
);

function resetForm() {
  form.value = getDefaultForm();
}



async function handleSubmit() {
  try {
    if (result.value?.isProfileChangeWindowOpen) {
      const result = await apolloClient.mutate({
        mutation: mutations.updateUser,
        variables: {
          payload: {
            behalfOf: props.user.uplineId,
            userId: form.value.userId,
            username: form.value.username,
            // password: form.value.password,
            creditGiven: form.value.creditGiven,
            status: form.value.status,
            userPermissions: {
              autoResetBalance: form.value.autoResetBalance,
              createAgent: form.value.createAgent,
              deleteBet: form.value.deleteBet,
              createPayment: form.value.createPayment,
              readStatement: form.value.statement,
              placeBets: form.value.placeBets
            },
            remarks: form.value.remarks
          }
        }
      });
      addSuccessToast("Downline updated");
      emit("submit");
    } else {
      const result = await apolloClient.mutate({
        mutation: mutations.updateUserCredit,
        variables: {
          payload: {
            behalfOf: props.user.uplineId,
            creditGiven: form.value.creditGiven,
            userId: form.value.userId
          }
        }
      });
      addSuccessToast("Downline credit updated");
      emit("submit");
    }

    toggleModal(false);
  } catch (err) {
    errorMutationNotification(err);
  }
}


return { __sfc: true,props, form, emit, $t, result, toggleModal, getDefaultForm, handleStatusChange, resetForm, handleSubmit, InputGroup }
}

})